/** Contains all breadcrumb flavors
 * Not converted to human readable text
 * ex. EFlavorsRaw.ad_click -> 'ad_click'
 */
export enum EFlavorsRaw {
  ad_click = 'ad_click',
  ad_view = 'ad_view',
  blocked = 'blocked',
  bot_partner_message_link_click = 'bot_partner_message_link_click',
  bot_partner_message_unsubscribe = 'bot_partner_message_unsubscribe',
  bot_partner_message_view = 'bot_partner_message_view',
  bot_pinpoint_tracked_email_click = 'bot_pinpoint_tracked_email_click',
  bot_pinpoint_tracked_email_open = 'bot_pinpoint_tracked_email_open',
  bot_pinpoint_tracked_email_unsubscribe = 'bot_pinpoint_tracked_email_unsubscribe',
  contact_list_import = 'contact_list_import',
  conversation_response = 'conversation_response',
  convert = 'convert',
  created_by_import = 'created_by_import',
  custom = 'custom',
  dashboard_create = 'dashboard_create',
  dashboard_import = 'dashboard_import',
  dashboard_link_click = 'dashboard_link_click',
  dashboard_send_complete = 'dashboard_send_complete',
  dashboard_send_request = 'dashboard_send_request',
  dashboard_submit = 'dashboard_submit',
  dashboard_view = 'dashboard_view',
  deduplicated = 'deduplicated',
  donation = 'donation',
  email_bot_detection_click = 'email_bot_detection_click',
  email_link_click = 'email_link_click',
  email_not_sent_via_opt_out = 'email_not_sent_via_opt_out',
  email_preferences_resubscribe = 'email_preferences_resubsubscribe',
  email_preferences_update = 'email_preferences_update',
  email_send = 'email_send',
  email_view = 'email_view',
  form_submission = 'form_submission',
  form_view = 'form_view',
  imis_create = 'imis_create',
  imis_update = 'imis_update',
  page_link_click = 'page_link_click',
  page_view = 'page_view',
  partner_message_complaint = 'partner_message_complaint',
  partner_message_delivered = 'partner_message_delivered',
  partner_message_hardbounce = 'partner_message_hardbounce',
  partner_message_link_click = 'partner_message_link_click',
  partner_message_rendering_failure = 'partner_message_rendering_failure',
  partner_message_send = 'partner_message_send',
  partner_message_softbounce = 'partner_message_softbounce',
  partner_message_suppression = 'partner_message_suppression',
  partner_message_unsubscribe = 'partner_message_unsubscribe',
  partner_message_view = 'partner_message_view',
  pinpoint_tracked_email_click = 'pinpoint_tracked_email_click',
  pinpoint_tracked_email_complaint = 'pinpoint_tracked_email_complaint',
  pinpoint_tracked_email_delivered = 'pinpoint_tracked_email_delivered',
  pinpoint_tracked_email_hardbounce = 'pinpoint_tracked_email_hardbounce',
  pinpoint_tracked_email_open = 'pinpoint_tracked_email_open',
  pinpoint_tracked_email_rendering_failure = 'pinpoint_tracked_email_rendering_failure',
  pinpoint_tracked_email_send = 'pinpoint_tracked_email_send',
  pinpoint_tracked_email_softbounce = 'pinpoint_tracked_email_softbounce',
  pinpoint_tracked_email_suppression = 'pinpoint_tracked_email_suppression',
  pinpoint_tracked_email_unsubscribe = 'pinpoint_tracked_email_unsubscribe',
  raisers_edge_constituent_created = 'raisers_edge_constituent_created',
  raisers_edge_constituent_updated = 'raisers_edge_constituent_updated',
  raisers_edge_constituent_summary = 'raisers_edge_constituent_summary',
  raisers_edge_gift_added = 'raisers_edge_gift_added',
  raisers_edge_upsync_created = 'raisers_edge_upsync_created',
  raisers_edge_upsync_failed = 'raisers_edge_upsync_failed',
  raisers_edge_upsync_skipped = 'raisers_edge_upsync_skipped',
  report_link_click = 'report_link_click',
  report_view = 'report_view',
  shared_email_preferences_update = 'shared_email_preferences_update',
  update = 'update',
  updated_by_import = 'updated_by_import',
  user_create = 'user_create',
  user_update = 'user_update',
  zapier_import = 'zapier_import',
  zapier_update = 'zapier_update',
}

/** Strict set of flavors used in reports
 * Not converted to human readable text
 * ex. EReportFlavorsRaw.ad_click -> 'ad_click'
 */
export enum EReportFlavorsRaw {
  ad_click = 'ad_click',
  ad_view = 'ad_view',
  bot_pinpoint_tracked_email_click = 'bot_pinpoint_tracked_email_click',
  bot_pinpoint_tracked_email_open = 'bot_pinpoint_tracked_email_open',
  created_by_import = 'created_by_import',
  email_link_click = 'email_link_click',
  email_not_sent_via_opt_out = 'email_not_sent_via_opt_out',
  email_preferences_update = 'email_preferences_update',
  email_view = 'email_view',
  imis_create = 'imis_create',
  imis_update = 'imis_update',
  page_link_click = 'page_link_click',
  page_view = 'page_view',
  pinpoint_tracked_email_click = 'pinpoint_tracked_email_click',
  pinpoint_tracked_email_complaint = 'pinpoint_tracked_email_complaint',
  pinpoint_tracked_email_delivered = 'pinpoint_tracked_email_delivered',
  pinpoint_tracked_email_hardbounce = 'pinpoint_tracked_email_hardbounce',
  pinpoint_tracked_email_open = 'pinpoint_tracked_email_open',
  pinpoint_tracked_email_send = 'pinpoint_tracked_email_send',
  pinpoint_tracked_email_softbounce = 'pinpoint_tracked_email_softbounce',
  pinpoint_tracked_email_suppression = 'pinpoint_tracked_email_suppression',
  raisers_edge_constituent_created = 'raisers_edge_constituent_created',
  raisers_edge_constituent_summary = 'raisers_edge_constituent_summary',
  raisers_edge_constituent_updated = 'raisers_edge_constituent_updated',
  raisers_edge_gift_added = 'raisers_edge_gift_added',
  updated_by_import = 'updated_by_import',
}

/** Human readable flavors for UI display
 * ex. EFlavors.ad_click -> 'Clicked ad'
 */
export enum EFlavors {
  ad_click = 'Clicked ad',
  ad_view = 'Viewed ad',
  blocked = 'Blocked',
  bot_partner_message_link_click = 'Bot clicked partner message link',
  bot_partner_message_unsubscribe = 'Bot unsubscribed from partner message',
  bot_partner_message_view = 'Bot viewed partner message',
  bot_pinpoint_tracked_email_click = 'Bot clicked email',
  bot_pinpoint_tracked_email_open = 'Bot opened email',
  bot_pinpoint_tracked_email_unsubscribe = 'Bot unsubscribed from email',
  contact_list_import = 'Imported contact list',
  conversation_response = 'Conversation response',
  convert = 'Conversion pixel',
  created_by_import = 'Created by import',
  custom = 'Custom',
  dashboard_create = 'Created dashboard',
  dashboard_import = 'Imported contacts on partner dashboard',
  dashboard_link_click = 'Clicked dashboard link',
  dashboard_send_complete = 'Sent email from partner dashboard',
  dashboard_send_request = 'Scheduled email invite',
  dashboard_submit = 'Updated dashboard profile',
  dashboard_view = 'Viewed partner dashboard',
  deduplicated = 'Records merged',
  donation = 'Donation',
  email_bot_detection_click = 'Bot detection clicked email',
  email_link_click = 'Clicked link in email',
  email_not_sent_via_opt_out = 'Was not sent email via opt out',
  email_preferences_resubscribe = 'Resubscribed to email',
  email_preferences_update = 'Updated email preferences',
  email_send = 'Sent email',
  email_view = 'Viewed email',
  form_submission = 'Submitted form',
  form_view = 'Viewed form',
  imis_create = 'Created by iMIS',
  imis_update = 'Updated by iMIS',
  page_link_click = 'Clicked link on page',
  page_view = 'Viewed page',
  partner_message_complaint = 'Reported partner message as spam',
  partner_message_delivered = 'Received partner message',
  partner_message_hardbounce = 'Partner message hard bounce',
  partner_message_link_click = 'Clicked partner message link',
  partner_message_rendering_failure = 'Partner message rendering failed',
  partner_message_send = 'Was sent partner message',
  partner_message_softbounce = 'Partner message soft bounce',
  partner_message_suppression = 'Partner message was suppressed',
  partner_message_unsubscribe = 'Unsubscribed from partner message',
  partner_message_view = 'Viewed partner message',
  pinpoint_tracked_email_click = 'Clicked email',
  pinpoint_tracked_email_complaint = 'Reported email as spam',
  pinpoint_tracked_email_delivered = 'Received email',
  pinpoint_tracked_email_hardbounce = 'Hard bounce',
  pinpoint_tracked_email_open = 'Opened email',
  pinpoint_tracked_email_rendering_failure = 'Email template rendering failed',
  pinpoint_tracked_email_send = 'Was sent email',
  pinpoint_tracked_email_softbounce = 'Soft bounce',
  pinpoint_tracked_email_suppression = 'Email was suppressed',
  pinpoint_tracked_email_unsubscribe = 'Unsubscribed from email',
  raisers_edge_upsync_created = "Synced to Raiser's Edge NXT",
  raisers_edge_upsync_failed = "Raiser's Edge NXT sync failed",
  raisers_edge_upsync_skipped = "Matched in Raiser's Edge NXT",
  raisers_edge_constituent_created = "Created by Raiser's Edge NXT",
  raisers_edge_constituent_updated = "Updated by Raiser's Edge NXT",
  raisers_edge_constituent_summary = "Raiser's Edge NXT Giving Summary updated",
  raisers_edge_gift_added = "Raiser's Edge NXT gift added",
  report_link_click = 'Clicked report link',
  report_view = 'Viewed campaign report',
  shared_email_preferences_update = 'System updated email preferences',
  update = 'Profile update',
  user_create = 'Manually created',
  user_update = 'Manually updated',
  updated_by_import = 'Updated by import',
  zapier_import = 'Zapier import',
  zapier_update = 'Zapier update',
}
